import { type FC, type ReactElement } from "react"

import eq from "lodash-es/eq"
import isString from "lodash-es/isString"

import { buildCssClassName } from "@/3514/utils"
import { type IUseTranslation, type TTranslationKeys, useTranslation } from "@/hooks"

import { ESurveyStatus } from "../api"

type TProps = { status: ESurveyStatus | string }

const statusTranslationsMap: { [S in ESurveyStatus]: keyof TTranslationKeys } = {
    [ESurveyStatus.Completed]: "participantSide.surveysPage.surveysList.status.completed",
    [ESurveyStatus.InCompleted]: "participantSide.surveysPage.surveysList.status.inCompleted",
    [ESurveyStatus.Expired]: "participantSide.surveysPage.surveysList.status.expired"
}

const statusBackgroundsMap: { [S in ESurveyStatus]: string } = {
    [ESurveyStatus.Completed]: "completed",
    [ESurveyStatus.InCompleted]: "incompleted",
    [ESurveyStatus.Expired]: "expired"
}

const Badge: FC<TProps> = ({ status }: TProps): ReactElement => {
    const { t }: IUseTranslation = useTranslation()

    return (
        <div
            className={buildCssClassName(
                "surveys__list__item__status",
                isString(status) ? "" : { [statusBackgroundsMap[status]]: [statusTranslationsMap[status]] }
            )}
        >
            <span className={buildCssClassName({ "font-italic color-gray": eq(status, ESurveyStatus.Expired) })}>
                {isString(status) ? status : t(statusTranslationsMap[status])}
            </span>
        </div>
    )
}

export { Badge as SurveysDataListItemStatusBadge }
